<template>
  <div class="page-site-editor">
    <div class="page-site-editor__left">
      <div class="page-site-editor__group">
        <div class="page-site-editor__header">
          <h3 class="page-site-editor__title">组件配置</h3>
        </div>
        <div class="page-site-editor__body">
          <app-components :active="component" :components="pageConfig.components" @select="handleComponentSelect"></app-components>
        </div>
      </div>
      <div class="page-site-editor__group">
        <div class="page-site-editor__header">
          <h3 class="page-site-editor__title">通用配置</h3>
        </div>
        <div class="page-site-editor__body">
          <app-components :active="component" :components="templateConfig.components" @select="handleComponentSelect"></app-components>
        </div>
      </div>
    </div>
    <div class="page-site-editor__right">
      <div class="page-site-editor__header">
        <h3 class="page-site-editor__title">
          <span>{{ pageConfig.label }}</span>
          <span class="page-site-editor__title-tip">(预览)</span>
        </h3>
      </div>
      <div class="page-site-editor__body">
        <iframe class="page-site-editor__view" ref="previewIframe" :src="iframeSrc" frameborder="0" :key="pageName"></iframe>
        <div class="page-site-editor__property" v-show="component.name">
          <div class="page-site-editor__property-header">
            <span>{{ component.label }}配置</span>
            <a class="page-site-editor__btn-close" href="javascript:;" @click="handleBtnCloseClick">
              <app-svg-icon icon-class="close"></app-svg-icon>
            </a>
          </div>
          <div class="page-site-editor__property-body">
            <app-component-setting :component="component" @reset="handleReset" @save="handleSave"></app-component-setting>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppComponents from './AppComponents'
import AppComponentSetting from './AppComponentSetting'

const { VUE_APP_CLOUD_SITE_SERVER } = process.env

export default {
  name: 'page-site-editor',
  components: {
    AppComponents,
    AppComponentSetting
  },

  data () {
    return {
      iframeSrc: '',
      component: {}
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },

    pageName () {
      const { name } = this.$route.query
      return name || ''
    },

    themeConfig () {
      return this.$store.state.themeConfig.config
    },

    templateConfig () {
      const { current, templates } = this.$store.state.themeConfig.config
      return templates[current]
    },

    pageConfig () {
      const { name } = this.$route.query
      const { current, templates } = this.$store.state.themeConfig.config

      return templates[current]['pages'][name] || {}
    },

    article () {
      const detail = this.$store.state.article.detail
      return detail.list[0]
    }
  },

  created () {
    this.getSiteThemeConfig()
    if (this.pageName === 'articleDetail') {
      if (!this.article) {
        this.getArticles(() => {
          this.setIframeSrc()
        })
      } else {
        this.setIframeSrc()
      }
    } else {
      this.setIframeSrc()
    }
  },

  methods: {
    setSiteThemeConfig (config, cb) {
      this.$store.dispatch('setSiteThemeConfig', {
        params: { userId: this.user.id },
        body: { config }
      }).then(() => {
        cb && cb(null)
      }).catch(error => {
        console.log('[DEBUG]', error)
        cb && cb(error)
      })
    },

    getSiteThemeConfig () {
      this.$store.dispatch('getSiteThemeConfig', {
        params: { userId: this.user.id }
      })
    },

    // 获取文章列表
    getArticles (cb) {
      this.$store.dispatch('getArticleDetails', {
        params: { userId: this.user.id },
        query: {
          status: [ 5, 105 ],
          offset: 0,
          limit: 10
        }
      }).then(response => {
        cb && cb()
      })
    },

    setIframeSrc () {
      const { name } = this.$route.query
      let url = `${VUE_APP_CLOUD_SITE_SERVER}/u/${this.user.id}/${name}`

      if (name === 'articleDetail') {
        url = `${VUE_APP_CLOUD_SITE_SERVER}/a${this.article.id}`
      }

      this.iframeSrc = url
    },

    refreshIframe () {
      this.$refs.previewIframe.src = this.iframeSrc
    },

    closeSettingPanel () {
      this.component = {}
    },

    handleComponentSelect (component) {
      if (this.component.name !== component.name) {
        this.component = component
      } else {
        this.component = {}
      }
    },

    handleBtnCloseClick () {
      this.closeSettingPanel()
    },

    handleReset () {
      this.setSiteThemeConfig(this.themeConfig, (error) => {
        if (!error) {
          this.$message({
            message: '重置成功',
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.refreshIframe()
            }
          })
        } else {
          this.$message({
            message: '重置失败',
            type: 'error'
          })
        }
      })
    },

    handleSave () {
      this.closeSettingPanel()
      this.setSiteThemeConfig(this.themeConfig, (error) => {
        if (!error) {
          this.$message({
            message: '保存成功',
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.refreshIframe()
            }
          })
        } else {
          this.$message({
            message: '保存失败',
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.page-site-editor {
  display: flex;
  min-height: 100%;
  background-color: #fff;

  &__left {
    display: flex;
    flex-direction: column;
    width: 240px;
    border-right: 1px solid #eee;
  }

  &__right {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &__header {
    padding: 10px;
    border-bottom: 1px solid #eee;
  }

  &__body {
    position: relative;
    flex: 1;
  }

  &__title {
    margin: 0;

    &-tip {
      color: #999;
      font-size: 14px;
      font-weight: 400;
    }
  }

  &__btn-close {
    color: #999;
    transition: color .3s;

    .app-svg-icon {
      width: 14px;
      height: 14px;
    }
  }

  &__property {
    position: absolute;
    top: 0;
    left: 0;
    width: 450px;
    height: 100%;
    padding: 10px;
    border-right: 1px solid #eee;
    background-color: #fff;
    overflow-y: auto;

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      margin: -10px -10px 0;
      border-bottom: 1px solid #eee;
      background-color: #f8f8f8;
    }

    &-body {
      margin-top: 15px;
    }
  }

  &__view {
    width: 100%;
    height: 100%;
  }
}
</style>
